import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    filings: [],
    filingsMap: {
      'NF': 'Draft',
      'FI': 'Filed',
      'AF': 'Amended',
      'AP': 'Draft',
    },
  },
  getters: {
    /**
    * @desc returns user filed years, removes duplicates
    * @param { Object } state
    * @returns { Array }
    */
    userFiledYears (state) {
      return [ ...new Set(state.filings.reduce((result, filing) => {
        //catch for bad filing data without filing year
        if (filing.year) {
          result.push(parseInt(filing.year));
        }
        return result;
      }, [])) ];
    },

    /**
    * @desc returns filing information for each year
    * @param { Object } state
    * @param { String } year
    * @returns { Array }
    */
    filingsByYear: (state) => (year) => {
      return state.filings.filter(filing => {
        return parseInt(filing[ 'year' ]) === year;
      }).sort((a, b) => {
        return b.id - a.id;
      });
    },
    filingById: (state) => (id) => {
      return state.filings.filter(filing => {
        return parseInt(filing[ 'id' ]) === parseInt(id);
      });
    },
    getNextFilingScreen: (state, getters) => (currentScreen) => {
      const requiredFilingScreens = getters['filingScreens']('filing');
      if (currentScreen !== 'undefined' || currentScreen !== null) {
        let currentScreenIndex = requiredFilingScreens.indexOf(currentScreen);
        if (currentScreenIndex !== -1 && currentScreenIndex - 1 !== requiredFilingScreens.length) {
          return requiredFilingScreens[currentScreenIndex + 1];
        }
      }
      return null;
    },
    filingScreens: (state, getters, rootState) => (location) => {

      let filingScreens = [
        'file-now',
        'filer-information',
        'user-profile-update',
      ];

      let cityForm = 'N';
      let stateForm = 'N';
      let mayorForm = 'N';

      if (location === 'filing' && rootState.filing.filing) {
        cityForm = rootState.filing.filing.cityForm;
        stateForm = rootState.filing.filing.stateForm;
        mayorForm = rootState.filing.filing.mayorForm;
      } else if (location === 'profile') {
        cityForm = rootState.user.profile.cityForm;
        stateForm = rootState.user.profile.stateForm;
        mayorForm = rootState.user.profile.mayorForm;
      }

      if (cityForm === 'Y') {
        filingScreens.push('income-sources');
        filingScreens.push('creditors');
        filingScreens.push('real-estate');
        filingScreens.push('gifts');
        filingScreens.push('directorships');
        filingScreens.push('business-interest');
      }

      if (stateForm === 'Y') {
        filingScreens.push('income-sources');
        filingScreens.push('creditors');
        filingScreens.push('real-estate');
        filingScreens.push('gifts');
        filingScreens.push('directorships');
        filingScreens.push('business-interest');
        filingScreens.push('business-interest-transferred');
      }

      if (mayorForm === 'Y') {
        filingScreens.push('income-sources');
        filingScreens.push('gifts');
        filingScreens.push('directorships');
        // filingScreens.push('family');
      }

      filingScreens.push(
        'review-statements',
        'submit-statements',
        'statements-submitted',
      );

      return Array.from(new Set(filingScreens));
    },
  },
  mutations: {
    setUserFilings(state, filings) {
      Vue.set(state, 'filings', filings);
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    fetchPublicFilings ( { commit }, query) {
      return new Promise((resolve, reject) => {
        return this.$axios({
          method: 'get',
          url: `filings/public-search`,
          params: query,
        }).then(response => {
          return resolve(response.data);
        }).catch(error => {
          console.warn(error);
          return reject([]);
        });
      });
    },
    fetchUserFilings({ commit, rootState }, userId) {
      if (!userId) {
        userId = rootState.login.loggedIn.id;
      }
      return this.$axios.get(`${rootState.endpoints.filings}`, {
        params: {
          userId,
        },
      }).then((response) => {
        let filings = response.data;
        commit('setUserFilings', filings);
        return true;
      }).catch(error => {
        this.$error('We were unable to retrieve your filings. Please try refreshing this page, if the issue persists contact support');
        return error.message;
      });
    },
  },
};